// extracted by mini-css-extract-plugin
export default {"AssistantDialog":"ehOp3KDd-ZgysjSMO-73nw=="};